import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { bonusEmojis, bonuses, offerIncludes } from '../data/content';
import { CTAButton } from './CTAButton';
export function Offer() {
  return <section className="relative w-full overflow-hidden bg-forest py-16 sm:py-24" aria-labelledby="oferta-title" style={{
    paddingTop: "6px",
    paddingBottom: "6px"
  }} data-id="element-80" data-mp="1mmqze89blrqt">
      {/* Detalles decorativos */}
      <div className="pointer-events-none absolute -left-16 top-10 h-56 w-56 rounded-full bg-olive/40 blur-2xl" aria-hidden="true" data-id="element-81" data-mp="u0xu9s0jy10v" />
      <div className="pointer-events-none absolute -right-20 bottom-0 h-64 w-64 rounded-full bg-sage/25 blur-2xl" aria-hidden="true" data-id="element-82" data-mp="13wrb3nlb0gog" />

      <div className="relative mx-auto max-w-3xl px-5" data-id="element-83" data-mp="yx525qcidmlg">
        <div className="text-center" data-id="element-84" data-mp="2fbxvz1p7s79f">
          <h2 id="oferta-title" className="mt-3 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-85" data-mp="2fav68x3moav3">
            🚀 Todo lo que incluye Negocio Rentable
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.45
      }} className="relative mt-12 rounded-3xl bg-white shadow-lift" data-id="element-86" data-mp="pjpapzky4wpe">
          {/* Cinta de descuento */}
          <span className="absolute -top-5 left-1/2 z-10 -translate-x-1/2 -rotate-2 whitespace-nowrap rounded-full bg-black px-5 py-2 font-display text-xs font-extrabold uppercase tracking-wide text-white shadow-lift sm:text-sm" data-id="element-87" data-mp="6tpqpr3yq7su">
            🔥 60% OFF solo por hoy
          </span>

          <div className="p-7 pt-10 sm:p-10 sm:pt-12" data-id="element-88" data-mp="fsb5rca874ov">
            <ul className="grid gap-3 sm:grid-cols-2" data-id="element-89" data-mp="km5w2ykc6hwx">
              {offerIncludes.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl border border-sage/50 bg-sage-mist/60 p-3" data-id="element-90" data-mp="3k95gy5ewyhdy">
                  <span className="text-xl leading-none" aria-hidden="true" data-id="element-91" data-mp="3o8wh2zqby9v5">
                    {item.emoji}
                  </span>
                  <span className="text-sm leading-snug text-forest-deep/85" data-id="element-92" data-mp="vde5qybdbq2h">
                    {item.text}
                  </span>
                </li>)}
            </ul>

            <div className="mt-7 rounded-2xl border-2 border-dashed border-olive bg-sage-mist p-5" data-id="element-93" data-mp="1550qpmdid3if">
              <p className="text-center font-display text-sm font-extrabold uppercase tracking-wide text-forest" data-id="element-94" data-mp="106z62x0fow4u">
                🎁 + 4 bonos de regalo 🎁
              </p>
              <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-95" data-mp="7itlqbdal95j">
                {bonuses.map((bonus, index) => <li key={bonus.label} className="flex items-start gap-2 rounded-lg bg-white/80 p-2.5 text-sm text-forest-deep/85" data-id="element-96" data-mp="lht7nb9f79y0" data-mpi={index}>
                    <span className="text-lg leading-none" aria-hidden="true" data-id="element-97" data-mp="heo7vggq5md2">
                      {bonusEmojis[index]}
                    </span>
                    <span className="leading-snug" data-id="element-98" data-mp="1svnze9v8zx61">{bonus.title}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 flex flex-col items-center border-t-2 border-dashed border-sage/70 pt-8 text-center" data-id="element-99" data-mp="20duinxe99xg8">
              <p className="text-sm font-semibold uppercase tracking-[0.16em] text-forest-deep/50" data-id="element-100" data-mp="25f1qfwgeewmw">
                Antes 🙈
              </p>
              <p className="font-display text-xl font-bold text-forest-deep/50 line-through" data-id="element-101" data-mp="1vfat7n0ge3j4">
                $49.990
              </p>
              <p className="mt-4 flex items-center gap-2 text-sm font-extrabold uppercase tracking-[0.16em] text-olive" data-id="element-102" data-mp="2j6gb07pyf5w2">
                <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="2o3geqbzbzwk0" />
                Hoy
              </p>
              <motion.p initial={{
              scale: 0.94,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.35,
              delay: 0.1
            }} className="font-display text-5xl font-extrabold tracking-tight text-black sm:text-6xl" data-id="element-104" data-mp="29d98cumlm3zo">
                $19.990
              </motion.p>
              <p className="mt-2 text-sm font-semibold text-forest" data-id="element-105" data-mp="1e71sy5kbbvxa">
                💚 Pago único · Sin suscripciones
              </p>

              <div className="mt-8 flex w-full justify-center" data-id="element-106" data-mp="198gry3x8l87s">
                <CTAButton data-id="element-107" data-mp="14a6xjvjc6bn8" />
              </div>

              <p className="mt-4 flex items-center gap-2 text-xs font-medium text-forest-deep/70" data-id="element-108" data-mp="14bi0xu8vdhdt">
                <ShieldCheckIcon className="h-4 w-4 text-olive" aria-hidden="true" data-id="element-109" data-mp="21yqgz9q3py8f" />
                Pago seguro 🔒 Acceso inmediato ⚡
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}